import React from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

interface CustomIconButtonProps extends IconButtonProps {
    onClick?: () => void;
}

const CustomIconButton: React.FC<CustomIconButtonProps> = ({ onClick, children, ...rest }) => {
    return (
        <IconButton onClick={onClick} {...rest}>
            {children}
        </IconButton>
    );
};

export default CustomIconButton;
